import { api } from "../../../infra/api";
import { URLS } from "../../../infra/URLS";
import Swal from 'sweetalert2'

export default async function putNotaFiscal(
  NotaFiscalId: number, 
  notaFiscalAtual: any,
  onSuccess: () => void,
) {
  
  return await api.put(`${URLS.NOTA_FISCAL_API}/${NotaFiscalId}`, notaFiscalAtual)
  .then((response) => {
    Swal.fire({
      title: 'Sucesso',
      text: 'Nota fiscal editada com sucesso!',
      icon: 'success',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#349946',
      allowOutsideClick: false
    }).then((response) => {
      if (response.isConfirmed) {
        onSuccess();
      }
    })
  })
  .catch((err) => {
    Swal.fire({
      title: 'Ocorreu um erro',
      text: err.response.data.message,
      icon: 'error',
      position: 'center',
      confirmButtonText: 'Ok',
      confirmButtonColor: '#F27474',
      allowOutsideClick: false
    })
  })
}
